import React from "react"
import { Navigation } from "app/navigation"
import { Messages } from "./components/messages"
import { ApprovalBanner } from "app/account/approval-banner"
import { FreeOverLimitBanner } from "./components/free-over-limit-banner"
import { CancellationPendingBanner } from "./components/cancellation-pending-banner"
import { UnconfirmedUserEmailBanner } from "app/account/unconfirmed-user-email-banner"
import { UnconfirmedSendAddressBanner } from "app/account/unconfirmed-send-address-banner"
import { UnpaidBanner } from "./components/unpaid-banner"
import { TrialEndedBanner } from "./components/trial-ended-banner"
import { RequiredInfoBanner } from "./components/required-info-banner"

function getLayoutConfig() {
  return window.app?.layoutConfig || { components: {} }
}

/**
 * ReactRbPageHeader renders navigation and banners for react-rb pages.
 *
 * Mirrors InertiaPageHeader but reads layout configuration from
 * window.app.layoutConfig (serialized by the ERB layout) instead of
 * Inertia's usePage() hook.
 *
 * @param {Object} props
 * @param {boolean} [props.bannersOnly] - When true, skip rendering Navigation (used inside vertical nav layout)
 */
export function ReactRbPageHeader({ bannersOnly = false } = {}) {
  const { components } = getLayoutConfig()

  return (
    <>
      {!bannersOnly &&
        components.navbar?.visible &&
        !components.verticalNav?.visible && (
          <Navigation {...components.navbar.data} />
        )}

      {components.messages?.visible && (
        <Messages {...components.messages.data} />
      )}

      {components.inReview?.visible && (
        <ApprovalBanner {...components.inReview.data} />
      )}

      {components.freeOverLimit?.visible && (
        <FreeOverLimitBanner {...components.freeOverLimit.data} />
      )}

      {components.cancellationPending?.visible && (
        <CancellationPendingBanner
          {...components.cancellationPending.data}
        />
      )}

      {components.unconfirmedUserEmail?.visible && (
        <UnconfirmedUserEmailBanner
          {...components.unconfirmedUserEmail.data}
        />
      )}

      {components.unconfirmedSendAddress?.visible && (
        <UnconfirmedSendAddressBanner
          {...components.unconfirmedSendAddress.data}
        />
      )}

      {components.unpaid?.visible && <UnpaidBanner />}

      {components.trialEnded?.visible && <TrialEndedBanner />}

      {components.requiredInfo?.visible && (
        <RequiredInfoBanner {...components.requiredInfo.data} />
      )}
    </>
  )
}
